import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { IRecupelItemDto } from 'gen/ApiClient';

export const RecupelCacheContext = React.createContext<ICacheContext<IRecupelItemDto[]>>(undefined as any);
